import { ProgramTypeDTO } from "../dto/ProgramTypeDTO";
import { ProgramType } from "../models/ProgramType";

export const programTypeMapper = (dto: ProgramTypeDTO): ProgramType => {
  return new ProgramType({
    id: dto.programId,
    name: dto.programName,
    active: dto.active === "Y",
  });
};
